import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = new URLSearchParams(loc.hash.replace(/^#/, ""));
    const sid = hash.get("session_id");
    const params = new URLSearchParams(loc.search);
    const role = params.get("role") === "carrier" ? "carrier" : "customer";
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sid, role });
        setUser(data);
        nav(data.role === "carrier" ? "/portal/carrier" : "/portal/customer", { replace: true });
      } catch {
        nav("/login?role=" + role, { replace: true });
      }
    })();
  }, [loc, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-slate-600">Completing sign in…</div>
    </div>
  );
}
